import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgText = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 30 30",
	...props,
	children: /* @__PURE__ */ _jsx("text", {
		x: 7.5,
		y: 25,
		style: {
			fontFamily: "Caros Soft, sans-serif",
			fontSize: 30
		},
		children: "T"
	})
});
export default SvgText;
